import React, { Component } from "react";
import { List, ListItem } from "material-ui/List";
import Checkbox from "material-ui/Checkbox";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";

class StateChanger extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    var that = this;
    let outputEvent = that.props.eventsOutput[0];
    function findEventForId(eventId, events) {
      function findEvent(localType) {
        return localType.id === eventId;
      }
      let found = events.find(findEvent);
      return found;
    }
    function findFlowForId(flowId) {
      function findFlow(flow) {
        return flow.id === flowId;
      }
      let found = that.props.allFlows.find(findFlow);
      return found;
    }
    function findForUiEventIdMatch(eventId) {
      return "->" + findEventForId(parseInt(eventId), that.props.uievents).name;
    }
    function findForFlowEventIdMatch(flowEventId) {
      let flowId = parseInt(flowEventId.split(".")[0]);
      let flow = findFlowForId(flowId);
      let eventId = parseInt(flowEventId.split(".")[1]);
      let eventName;
      if (eventId === 0) eventName = "any";
      else {
        let event = findEventForId(eventId, flow.eventsOutput);
        eventName = event.name;
      }
      return "->" + flow.title + ": " + eventName;
    }
    let sourceName;
    let id = this.props.stateChanger.eventSource.id;
    if (this.props.stateChanger.eventSource.type === "flow") {
      sourceName = findForFlowEventIdMatch(id);
    } else if (this.props.stateChanger.eventSource.type === "ui") {
      sourceName = findForUiEventIdMatch(id);
    }

    function findTargetNameForId(target) {
      function findAttr(all, needle) {
        function findIn(hay) {
          return hay.id === parseInt(needle.id);
        }
        return all.find(findIn);
      }
      let found;
      if (target.type === "attribute") {
        let attr = findAttr(outputEvent.attributes, target);
        if (attr.state) found = attr.state.title;
        else found = attr.name;
      } else if (target.type === "action")
        found = findAttr(outputEvent.actions, target).name;

      console.log(
        "type: " + target.type + " id: " + target.id + "   found: " + found
      );
      return found;
    }
    let changeTargets;
    if (this.props.stateChanger.changeTargets) {
      changeTargets = (
        <div>
          {this.props.stateChanger.changeTargets.map(target => {
            let targetName = findTargetNameForId(target);
            return <div>->{targetName}</div>;
          })}
        </div>
      );
    } else changeTargets = "";

    let details;
    if (this.state.expanded) {
      let text = this.props.stateChanger.changes;
      var that = this;
      function findAttrForId(id, attrs) {
        function findEvent(attr) {
          return attr.id === id;
        }
        let found = attrs.find(findEvent);
        return found;
      }
      function findAction(m, p1) {
        return (
          "`" + findAttrForId(parseInt(p1), outputEvent.actions).name + "`->"
        );
      }
      function findAttr(m, p1) {
        return (
          "`" + findAttrForId(parseInt(p1), outputEvent.attributes).name + "`->"
        );
      }
      text = text.replace(/\*\*\*(\d+)\*\*\*/g, findAction);
      text = text.replace(/\*\*(\d+)\*\*/g, findAttr);
      details = (
        <p style={{ textAlign: "left" }}>
          <ReactMarkdown source={text} />
        </p>
      );
    } else {
      details = "";
    }
    return (
      <Card
        style={{ width: "fit-content" }}
        onClick={e => {
          e.stopPropagation();
          this.handleClick(e);
        }}
      >
        <CardContent
          style={{
            padding: 4,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <p>
            <span style={{ fontSize: 12 }}>
              <i>{sourceName}</i>
            </span>
            <br />
            <span style={{ fontSize: 12 }}>{details}</span>
          </p>
          <div
            style={{
              paddingLeft: 20,
              fontSize: 12,
              display: "flex",
              flexDirection: "column"
            }}
          >
            {changeTargets}
          </div>
        </CardContent>
      </Card>
    );
  }
}

export default StateChanger;



// WEBPACK FOOTER //
// ./src/components/StateChangerOld.js